import { userConstants } from "../../constant";
export function myNda(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_MY_NDAPROPOSAL:
      return action.proposals;
     case userConstants.GET_PURCHASED_NDA:
      return action.nda;
    default:
      return state;
  }
}
